import { FocusArrowNavigator } from './FocusArrowNavigator';
import { FocusScope } from './FocusScope';

export const Focus = {
  Scope: FocusScope,
  ArrowNavigator: FocusArrowNavigator,
};
